export default __webpack_public_path__ + "static/media/close.b4c78aac.svg";